import { Dialog } from '@mui/material';
import React from 'react'
import {ReactComponent as TickIcon} from "../../../../../../../assets/img/svg/TickWhite.svg"

const ConfirmationDialog=(
    {isOpen}
)=>{
   const style={
        borderRadius:'100px',
        background: 'var(--Positive-Positive-50, #05945B)',
        width: '56px',
height: '56px',
padding: '4px',

alignItems: 'center'
    }
return(

        <Dialog open={isOpen}  size="sm">
            <div className='m-3'>
          <div ><TickIcon style={style}/></div>
          <div className='large-text mt-2'>
            File uploaded successfully
          </div>
          </div>
        </Dialog>
)
}
export default ConfirmationDialog